import React from 'react';
import { Navigate } from 'react-router-dom';
import CultureIndex from 'views/Meteorology/Agro/CultureIndex';
import Area from 'views/Meteorology/Agro/CultureIndex/Area';
import Location from 'views/Meteorology/Agro/CultureIndex/Location';

const cultureIndexRouter = {
  path: 'culture-index',
  element: <CultureIndex />,
  children: [
    { path: '', element: <Navigate to="area" replace /> },
    { path: 'area', element: <Area /> },
    { path: 'location', element: <Location /> },
  ],
};

export default cultureIndexRouter;
